import React from 'react';
import { useStyles } from './Themable.hooks';

import { Paper } from '@material-ui/core';
import DevicesPreview from './components/DevicesPreview';
import { useDevicesMode } from '../../../../../../state/ui/devices/index.hooks';

const DevicePane = () => {
    const classes = useStyles();

    const mode = useDevicesMode();
    const renderDevicesPane = () => {
        switch (mode) {
            case 'preview':
                return <DevicesPreview />;

            default:
                return;
        }
    };

    return (
        <Paper className={classes.pane}>
            <div className={classes.wrapper}>{renderDevicesPane()}</div>
        </Paper>
    );
};

export default DevicePane;
